import { useContext, useEffect } from 'react';
import MenuContext from 'shared/components/AppRouter/context/MenuContext'
import filterPages from 'shared/utils/filterPages'


interface useInitProps {
    setPages: Function
    position?: String | boolean | undefined
}

const useInit = (props: useInitProps) => {
    
    const pages = useContext(MenuContext)

    const filteredPages = filterPages(pages, 'left')
    
    useEffect(() => {
        props.setPages(filteredPages)
    }, [])
}

export default useInit